module.exports = __webpack_public_path__ + "img/1728349179979-Screenshot_8-10-2024_85918_www.instagram.com.jpeg.8e8cb321.webp";